import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "30px 0",
  backgroundColor: "#fff",
  borderRadius: "8px",
  boxShadow: "0 1px 5px rgba(0, 0, 0, 0.1)",
  marginBottom: "20px",

  [theme.down("sm")]: {
    padding: "20px 10px",
  },
}));

export const Step = styled("div")(({ theme, $isActive, $isCompleted }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 8,
  minWidth: 100,

  [theme.down("sm")]: {
    minWidth: "auto",
    flex: 1,
  },
}));

export const StepIcon = styled("div")(({ theme, $isActive, $isCompleted }) => ({
  width: 40,
  height: 40,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 16,
  fontWeight: 600,
  backgroundColor: $isCompleted ? "#4caf50" : $isActive ? "#0052ff" : "#e0e0e0",
  color: $isCompleted || $isActive ? "#fff" : "#999",
  border: `2px solid ${$isCompleted ? "#4caf50" : $isActive ? "#0052ff" : "#e0e0e0"}`,
  transition: "all 0.3s ease",

  [theme.down("sm")]: {
    width: 32,
    height: 32,
    fontSize: 14,
  },
}));

export const StepLabel = styled("span")(({ theme, $isActive }) => ({
  fontSize: 14,
  fontWeight: $isActive ? 600 : 400,
  color: $isActive ? "#1a1a1a" : "#666",
  textAlign: "center",

  [theme.down("sm")]: {
    fontSize: 11,
    display: "none",
  },
}));

export const StepDivider = styled("div")(({ theme, $isCompleted }) => ({
  flex: 1,
  height: 2,
  backgroundColor: $isCompleted ? "#4caf50" : "#e0e0e0",
  margin: "0 10px",
  maxWidth: 100,
  transition: "background-color 0.3s ease",

  [theme.down("sm")]: {
    maxWidth: 30,
    margin: "0 5px",
  },
}));

